import KinvaDocShow from './KinvaDocShow'
export {KinvaDocShow}
export default KinvaDocShow
